export const sortOrderExist = (arr: any[], order: number): boolean => arr
  .map((element) => element.sort_order)
  .includes(Number(order));

export default sortOrderExist;
